module.exports = __webpack_public_path__ + "static/media/workingmemory-words-6.d70fc9ea.mp3";